/* Fuel Lodge: local delivery postcode checker.
 * Looks up UK postcodes with postcodes.io and measures the straight-line
 * distance from the yard. Used on the homepage (all zones) and on local-only
 * products (single radius, locks Add to cart until the postcode is in range).
 */
(function () {
  if (customElements.get('fl-postcode-check')) return;

  var STORE_KEY = 'fl_postcode';
  var cache = {};

  function clean(pc) { return String(pc || '').toUpperCase().replace(/[^A-Z0-9]/g, ''); }
  function pretty(pc) { pc = clean(pc); return pc.length > 3 ? pc.slice(0, -3) + ' ' + pc.slice(-3) : pc; }
  function looksValid(pc) { return /^[A-Z]{1,2}[0-9][A-Z0-9]?[0-9][A-Z]{2}$/.test(clean(pc)); }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function lookup(pc) {
    var key = clean(pc);
    if (cache[key]) return cache[key];
    cache[key] = fetch('https://api.postcodes.io/postcodes/' + encodeURIComponent(key))
      .then(function (r) { return r.json(); })
      .then(function (d) {
        if (!d || d.status !== 200 || !d.result) throw new Error('not_found');
        return { lat: d.result.latitude, lng: d.result.longitude };
      })
      .catch(function (e) { delete cache[key]; throw e; });
    return cache[key];
  }

  function miles(a, b) {
    var R = 3958.8, toRad = Math.PI / 180;
    var dLat = (b.lat - a.lat) * toRad, dLng = (b.lng - a.lng) * toRad;
    var h = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
      Math.cos(a.lat * toRad) * Math.cos(b.lat * toRad) * Math.sin(dLng / 2) * Math.sin(dLng / 2);
    return 2 * R * Math.asin(Math.sqrt(h));
  }

  function save(pc) { try { localStorage.setItem(STORE_KEY, clean(pc)); } catch (e) {} }
  function load() { try { return localStorage.getItem(STORE_KEY) || ''; } catch (e) { return ''; } }

  class FlPostcodeCheck extends HTMLElement {
    connectedCallback() {
      if (this._init) return;
      this._init = true;
      this.mode = this.dataset.mode || 'home';
      this.origin = this.dataset.origin || 'DY9 7BZ';
      this.phone = this.dataset.phone || '';
      this.email = this.dataset.email || '';
      this.input = this.querySelector('.fl-pc__input');
      this.result = this.querySelector('.fl-pc__result');
      this.inner = this.result.firstElementChild || this.result;
      this.form = this.querySelector('form');

      if (this.mode === 'product') this.setupProduct();

      this.form.addEventListener('submit', (e) => { e.preventDefault(); this.check(this.input.value); });

      var saved = load();
      if (saved) { this.input.value = pretty(saved); this.check(saved, true); }
    }

    setupProduct() {
      this.radius = parseFloat(this.dataset.radius || '7');
      // Put the box right above the buy buttons
      var box = this.closest('.fl-local');
      var pf = document.querySelector('product-info product-form, .product__info-container product-form');
      if (box && pf && pf.parentElement && pf.parentElement.parentElement) {
        pf.parentElement.parentElement.insertBefore(box, pf.parentElement);
        var section = document.querySelector('[data-fl-local-section]');
        if (section) section.hidden = true;
      }
      this.gate(true);
      document.addEventListener('submit', function (e) {
        var t = e.target;
        if (document.body.classList.contains('fl-local-gated') && t && t.closest && t.closest('product-form')) {
          e.preventDefault(); e.stopImmediatePropagation();
          var input = document.querySelector('.fl-local .fl-pc__input');
          if (input) input.focus();
        }
      }, true);
    }

    gate(on) { document.body.classList.toggle('fl-local-gated', !!on); }

    show(kind, html) {
      this.inner.innerHTML = '<div class="fl-pc__msg fl-pc__msg--' + kind + '">' + html + '</div>';
      this.result.classList.add('is-open');
    }

    contactHtml() {
      var bits = [];
      if (this.phone) bits.push('call <a href="tel:' + esc(this.phone.replace(/\s/g, '')) + '">' + esc(this.phone) + '</a>');
      if (this.email) bits.push('email <a href="mailto:' + esc(this.email) + '">' + esc(this.email) + '</a>');
      return bits.join(' or ');
    }

    check(raw, quiet) {
      if (!looksValid(raw)) {
        if (!quiet) this.show('err', '<strong>That doesn’t look like a UK postcode.</strong>Try something like DY8 1AB.');
        return;
      }
      var pc = pretty(raw);
      this.show('err', '<span class="fl-pc__busy">Checking ' + esc(pc) + '…</span>');
      Promise.all([lookup(this.origin), lookup(raw)]).then((res) => {
        var d = miles(res[0], res[1]);
        save(raw);
        var dist = d < 1 ? 'less than a mile' : d.toFixed(1) + ' miles';
        if (this.mode === 'product') this.renderProduct(pc, d, dist);
        else this.renderHome(pc, d, dist);
      }).catch(() => {
        if (this.mode === 'product') this.gate(true);
        this.show('err', '<strong>We couldn’t find ' + esc(pc) + '.</strong>Check it and try again. You can also ' + this.contactHtml() + '.');
      });
    }

    renderProduct(pc, d, dist) {
      if (d <= this.radius) {
        this.gate(false);
        this.show('ok', '<strong>Good news, we deliver to ' + esc(pc) + ' for free.</strong>You’re ' + dist + ' from our yard. Add it to your basket and we’ll call to arrange a day.');
      } else {
        this.gate(true);
        this.show('no', '<strong>' + esc(pc) + ' is ' + dist + ' away, outside our free ' + this.radius + ' mile area.</strong>We can still deliver. Just ' + this.contactHtml() + ' and we’ll give you a price.');
      }
    }

    renderHome(pc, d, dist) {
      var zones = [];
      try { zones = JSON.parse(this.dataset.zones || '[]'); } catch (e) {}
      var inAny = false;
      var lines = zones.map(function (z) {
        var ok = d <= z.radius;
        if (ok) inAny = true;
        return '<li class="' + (ok ? 'is-yes' : '') + '">' + esc(z.label) + ': ' + (ok ? 'free delivery' : 'outside our ' + z.radius + ' mile area, call for a price') + '</li>';
      });
      lines.push('<li class="is-yes">Everything else: free UK courier delivery</li>');
      this.show(inAny ? 'ok' : 'no',
        '<strong>' + esc(pc) + ' is ' + dist + ' from our yard.</strong>' +
        '<ul class="fl-pc__lines">' + lines.join('') + '</ul>');
    }
  }

  customElements.define('fl-postcode-check', FlPostcodeCheck);
})();
